/**
 * Qué idiomas existen para cada ruta.
 *
 * es/en/it/pt cubren todo el sitio. de/fr (añadidos el 16-9-2026 para Suiza,
 * Austria, Alemania, Francia, Bélgica y Luxemburgo) cubren SOLO las páginas de
 * producto: portada, herramientas gratuitas, páginas «X a Excel» y sectores.
 * El blog y las páginas legales no están traducidos a de/fr, salvo los artículos
 * que declaran `langs` (ver src/data/postLangs.json).
 *
 * Esto importa por SEO: publicar /de/blog/... con el texto en inglés serían
 * páginas duplicadas en el idioma equivocado. Así que:
 *  - hreflang y sitemap solo declaran los idiomas que existen para esa ruta;
 *  - una ruta de/fr que no existe redirige a su versión en inglés.
 */
import POST_LANGS from "../data/postLangs.json";
import TOOL_LANGS from "../data/toolLangs.json";

export const FULL_LANGS = ["en", "es", "it", "pt"];
export const PARTIAL_LANGS = ["de", "fr"];

const PARTIAL_PATHS = [
  /^$/,
  /^free$/,
  /^id-scanner$/,
  /^mrz-checker$/,
  /^business-card-scanner$/,
  /^(invoice|receipt|delivery-note|quote|purchase-order|bank-statement|business-cards|scanned-pdf)-to-excel$/,
  /^sector\/[a-z]+$/,
];

const clean = (p) => String(p || "").replace(/^\/+|\/+$/g, "").split(/[?#]/)[0];

/** Idiomas disponibles para una ruta SIN el prefijo de idioma («free», «blog/x»). */
export function langsForPath(purePath) {
  const p = clean(purePath);
  // Artículos con idiomas propios (fase 4: e-factura por país, p. ej. en + fr).
  // Legales: el texto solo existe en inglés. Las copias es/it/pt eran duplicados
  // que Google marcaba «Rastreada: actualmente sin indexar».
  if (/^(terms|privacy|cookies|dpa|gdpr)$/.test(p)) return ["en"];
  // Herramientas de un solo país o de pocos idiomas: src/data/toolLangs.json (una única tabla; la
  // copian generate-sitemap.mjs y la función de CloudFront, ver zsh_scripts/cloudfront/sync_tool_langs.py).
  if (TOOL_LANGS[p]) return TOOL_LANGS[p];
  const post = p.match(/^blog\/([^/]+)$/);
  if (post && POST_LANGS[post[1]]) return POST_LANGS[post[1]];
  return PARTIAL_PATHS.some((re) => re.test(p)) ? [...FULL_LANGS, ...PARTIAL_LANGS] : FULL_LANGS;
}

export function isPathAvailable(lang, purePath) {
  return langsForPath(purePath).includes(lang);
}

/** Enlace a una ruta: si no existe en el idioma actual, a su versión en inglés. */
export function localizedPath(lang, purePath) {
  const p = clean(purePath);
  const l = isPathAvailable(lang, p) ? lang : "en";
  return `/${l}${p ? `/${p}` : ""}`;
}
